import { makeStyles } from '@material-ui/core';

import { availabilityPickerHeight } from './AvailabilityPicker.utils';

export const useStyles = makeStyles(() => ({
  mobileContainer: {
    position: 'relative',
    width: '100%',
  },
  absoluteArrowsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    position: 'absolute',
    top: -15,
  },
  timePicker: {
    height: availabilityPickerHeight,
    width: 215,
  },
  mobileTimePicker: {
    height: availabilityPickerHeight,
    width: 215,
  },
  desktopContainer: {
    marginLeft: -16,
  },
}));
